import * as locCon from '../LocalConstants';

import { RefContextLanguage } from '../providers/LanguageProvider';
import CustomText from '../elements/CustomText';
import { useState } from 'react';
import { Input } from 'antd';
import CustomButton from '../elements/CustomButton';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import { setStoredValue } from '../hooks/StoreHooks';
import LoadingComponent from '../components/LoadingComponent';
import { nowISO } from '../community-hats-js-library/utils/dateFunctions';
import { clearApiToken, getApiToken } from '../utils/apiTokenFunctions';

export function Authenticate() {
  const i18n = RefContextLanguage();

  const [password, setPassword] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [showMessage, setShowMessage] = useState(false);

  const logIn = async () => {
    const response = await fetch('/.netlify/functions/checkPassword', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    });

    const { correct, token } = await response.json();

    if (!isNullOrUndefined(password) && correct) {
      setIsLoading(true);
      // The app token expires on the same schedule as LAST_LOG_IN. It is only
      // good for minting the API token below, which is what actually reaches
      // the server.
      setStoredValue(locCon.APP_TOKEN, token);

      // Minted before LAST_LOG_IN, because setting that is what puts the app
      // on screen, and the first thing it does is call the back end. Not gated
      // on success: a failure here surfaces as the same per call error any
      // other transport failure would.
      clearApiToken();
      await getApiToken();

      setStoredValue(locCon.LAST_LOG_IN, nowISO());
      //window.location.reload();
      setShowMessage(false);
    } else setShowMessage(true);
  };

  return isLoading ? (
    <LoadingComponent />
  ) : (
    <div className="mainAppContainer">
      <div className="pageContainer">
        <div className="verticalSection" style={{ marginTop: '25vh' }}>
          <CustomText type={locCon.SECTION_TITLE_TEXT} style={{ marginBottom: '1vh' }}>
            {i18n.t('enterPassword')}
          </CustomText>
          <Input.Password
            style={styles.input}
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            placeholder={i18n.t('password')}
          />
          <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => logIn()}>
            {i18n.t('enter')}
          </CustomButton>
          <div className="verticalSection">
            {showMessage ? <CustomText type={locCon.DANGER_TEXT}>{i18n.t('wrongPassword')}</CustomText> : <div></div>}
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  input: {
    backgroundColor: 'var(--primary-color-5)',
    color: 'var(--primary-color-3)',
    fontSize: 16,
    marginBottom: '2vh',
    width: '100%',
  },
};

export default Authenticate;
